import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { Checkbox } from '@components/Checkbox';
import UnverifiedBadge from '@components/UnverifiedBadge';
import { generateCompanyCardAddress } from '@helpers/companies';

const CardWrapper = styled('div', {
    shouldForwardProp: prop => prop !== 'isActive',
})(({ isActive }) => ({
    padding: '8px 16px 16px 9px',
    display: 'flex',
    width: '100%',
    cursor: 'pointer',
    boxShadow: 'none',
    border: '1px solid var(--divider)',
    borderRadius: 8,
    backgroundColor: isActive ? 'var(--action-highlight)' : '#fff',
    '&:hover': {
        backgroundColor: 'var(--action-highlight)',
    },
}));

const StyledCheckbox = styled(Checkbox)({
    height: 30,
    padding: 7,
    marginRight: 10,
    '& svg': {
        width: 18,
    },
});

const GoogleCompanyItem = ({ location = {}, selectedCompanies, setCompany }) => {
    const isActive = selectedCompanies.some(c => c.locationId === location.locationId);

    return (
        <CardWrapper onClick={() => setCompany(location)} isActive={isActive}>
            <StyledCheckbox
                inputProps={{ 'aria-label': 'controlled' }}
                onChange={() => setCompany(location)}
                checked={isActive}
            />
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <Typography variant="subtitle1">{location.title}</Typography>
                {location.country && (
                    <Typography variant="body2" sx={{ color: 'var(--text-secondary)', margin: '2px 0 6px' }}>
                        {generateCompanyCardAddress(location)}
                    </Typography>
                )}
                {location.primaryPhoneNumber && (
                    <Typography variant="caption" sx={{ color: 'var(--text-tertiary)' }}>
                        {location.primaryPhoneNumber}
                    </Typography>
                )}
                {!location.isVerified && <UnverifiedBadge />}
            </div>
        </CardWrapper>
    );
};

export default GoogleCompanyItem;
